/**
 * Estado del teclado en pantalla de las pantallas de acceso (login y recuperar contraseña): el interruptor,
 * lo que se recuerda en el equipo y cuándo se abre. Cada pantalla pone lo suyo: qué campos tiene, su valor
 * (`valorCampo`) y qué hace «Siguiente» (`accionTeclado`).
 */
export default {
  data: () => ({
    keyboardMode: false,
    campoActivo: null,
    tecladoOculto: false,
  }),
  computed: {
    tecladoAbierto() {
      return this.keyboardMode && !!this.campoActivo && !this.tecladoOculto;
    },
  },
  watch: {
    campoActivo() {
      // Tocar un campo vuelve a mostrar el teclado que se ocultó.
      this.tecladoOculto = false;
    },
    tecladoAbierto(abierto) {
      if (abierto) {
        // El teclado ocupa el pie de la pantalla: se sube la tarjeta para que el campo quede a la vista.
        this.$nextTick(() => {
          const tarjeta = this.$el.querySelector(".login-tarjeta");
          if (tarjeta) tarjeta.scrollIntoView({ block: "start", behavior: "smooth" });
        });
      }
    },
    keyboardMode(activo) {
      if (!activo) this.campoActivo = null;
      try {
        localStorage.setItem("login_teclado", activo ? "1" : "0");
      } catch (e) {
        // sin almacenamiento el interruptor funciona igual, solo no se recuerda
      }
    },
  },
  mounted() {
    this.keyboardMode = this.tecladoInicial();
  },
  methods: {
    /**
     * Lo que se eligió la última vez en este equipo; si nunca se eligió, se enciende solo cuando el equipo
     * es táctil, no tiene mouse y la pantalla es grande (un POS sin teclado). En un celular queda apagado:
     * ahí el teclado del propio teléfono es mejor (pegar la clave, el gestor de contraseñas, el autocompletar).
     */
    tecladoInicial() {
      try {
        const guardado = localStorage.getItem("login_teclado");
        if (guardado !== null) {
          return guardado === "1";
        }
        return (
          window.matchMedia("(any-pointer: coarse)").matches &&
          !window.matchMedia("(any-pointer: fine)").matches &&
          window.matchMedia("(min-width: 900px)").matches
        );
      } catch (e) {
        return false;
      }
    },
  },
};
